import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileRename from "filepond-plugin-file-rename";
import FilePondPluginGetFile from "filepond-plugin-get-file";
import "@/assets/css/filepond.min.css";
import "@/assets/css/filepond-plugin-get-file.css";

export default new vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginFileRename, FilePondPluginGetFile);



// WEBPACK FOOTER //
// ./src/plugins/filepond.js